<template>
  <div class="elite-tabs-wrapper-content">
    <div class="resume-header">
      <div class="resume-header-image">
        <img
          v-if="user.profile_image"
          :src="`${user.profile_image}`"
          class="argon-image"
        />
        <img v-else src="/img/add-image.svg" class="default" />
      </div>
      <div class="resume-header-text">
        <h3>{{ user.first_name }} {{ user.last_name }}</h3>
        <ul>
          <li>{{ user.email }}</li>
        </ul>
        <div class="resume-header-text-button">
          <button class="btn" @click="onUpdateUser">
            <span> {{ $t("COMMON.UPDATE") }} </span>
            <i class="far fa-edit"></i>
          </button>
          <button
            v-if="canDeactivateUser"
            class="btn"
            @click="$emit('onDeactivateUser')"
          >
            <span> {{ $t("USERS.DEACTIVATE_USER") }} </span>
          </button>
          <button
            v-if="canActivateUser"
            class="btn"
            @click="$emit('onActivateUser')"
          >
            <span> {{ $t("USERS.ACTIVATE_USER") }} </span>
          </button>
          <button v-if="canSendInvitation" class="btn" @click="inviteUser">
            <span> {{ $t("COMMON.SEND_INVITATION") }} </span>
            <i class="fas fa-spinner fa-spin mr-1" v-if="loading"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="resume-list">
      <div class="resume-list-inner">
        <dl class="width_1-2">
          <dt>{{ $t("USERS.ACTIVE") }}</dt>
          <dd>
            <icon-check :checked="!!user.active" />
          </dd>
        </dl>

        <dl class="width_1-2" v-if="$currentUser() && $currentUser().is_admin">
          <dt>{{ $t("USERS.IS_STAFF") }}</dt>
          <dd>
            <icon-check :checked="!!user.is_admin" />
          </dd>
        </dl>

        <dl class="width_1-2">
          <dt>{{ $t("USERS.RESTRICT_TO_CLIENTS") }}</dt>
          <dd>
            <icon-check :checked="!!user.restricted_to_clients" />
          </dd>
        </dl>

        <dl class="width_1-2">
          <dt>{{ $t("COMMON.CREATED_AT") }}</dt>
          <dd v-if="user.createdAt">
            {{ $timeZoneDateFormat(user.createdAt) }}
          </dd>
        </dl>

        <dl class="width_1-2">
          <dt>{{ $t("COMMON.UPDATED_AT") }}</dt>
          <dd v-if="user.updatedAt">
            {{ $timeZoneDateFormat(user.updatedAt) }}
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
import IconCheck from "@/components/IconCheck.vue";
import BillingInformationsView from "@/components/BillingInformationsView.vue";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { mapGetters } from "vuex";

export default {
  name: "user-view-global",

  components: { IconCheck, BillingInformationsView },

  mixins: [requestErrorMixin],

  props: ["user"],

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapGetters("profile", { me: "me" }),

    canSendInvitation() {
      return (
        false &&
        this.$currentUserCan(this.$permissions.PERM_CREATE_USERS) &&
        this.user.email != this.me.email
      );
    },

    canActivateUser() {
      return (
        this.user.is_admin &&
        this.user.email != this.me.email &&
        !this.user.active
      );
    },

    canDeactivateUser() {
      return (
        this.user.is_admin &&
        this.user.email != this.me.email &&
        this.user.active
      );
    },
  },

  methods: {
    onUpdateUser() {
      this.$emit("onUpdateUser");
    },
    async inviteUser() {
      try {
        this.loading = true;

        await this.$store.dispatch("users/invite", this.user.id);

        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("COMMON.INVITATION_SENT"),
        });
      } catch (error) {
        await this.showRequestError(error);
      } finally {
        this.loading = false;
      }
    },
  },

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
